import { component } from 'picoapp';

export default component(async (node) => {
  const videoElement: HTMLVideoElement = node.querySelector('[data-video]');
  const dataSource = JSON.parse(videoElement.dataset.source);
  const playButton: HTMLButtonElement = node.querySelector('[data-play]');
  const overlay: HTMLElement = node.querySelector('[data-overlay]');

  const getExtension = (url) => url.split(/[#?]/)[0].split('.').pop().trim();

  const insertSource = (source) => {
    const type = `video/${getExtension(source)}`;
    videoElement.insertAdjacentHTML(
      'beforeend',
      `<source src="${source}#t=0.001" type="${type}">`
    );
  };

  playButton.addEventListener('click', () => {
    videoElement.play();
    videoElement.setAttribute('controls', 'true');
    playButton.hidden = true;
    overlay.hidden = true;
  });

  const observer = new IntersectionObserver((entires) => {
    entires.forEach((entry) => {
      if (entry.isIntersecting) {
        insertSource(dataSource);

        // Auto-play on desktop (screen width > 1024px)
        if (window.innerWidth > 1024) {
          videoElement.muted = true;
          videoElement.play();
          videoElement.setAttribute('controls', 'true');
          playButton.hidden = true;
          overlay.hidden = true;
        }

        observer.disconnect();
      }
    });
  });

  observer.observe(node);
});
